import { render, staticRenderFns } from "./CustomMultipleSelect.vue?vue&type=template&id=977bc2b8&"
import script from "./CustomMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./CustomMultipleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports